import { AHButton, AHIcon, AHText, Box } from "arkh";
import React, { useEffect, useState } from "react";
import WebView from "react-native-webview";
import * as MailComposer from "expo-mail-composer";
import Constants from "expo-constants";
import { useUser } from "../../OS/Login/State";
import { getAuthSession } from "../../OS/Client";
import { Platform, StyleSheet } from "react-native";
import { BlurView } from "expo-blur";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import * as Device from "expo-device";
export function SupportScreen() {
  const usr = useUser();

  const [isMailAvailable, setIsMailAvailable] = useState(false);

  useEffect(() => {
    MailComposer.isAvailableAsync().then((v) => {
      setIsMailAvailable(v);
    });
  }, []);
  const insets = useSafeAreaInsets();
  if (Platform.OS === "web") {
    return (
      <iframe
        src="https://storesprint.com/support"
        style={{ width: "100%", height: "100%" }}
      />
    );
  }

  return (
    <Box style={{ flex: 1 }}>
      <WebView
        source={{
          uri: `https://storesprint.com/support`,
        }}
      />
      {isMailAvailable ? (
        <Box
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            paddingBottom: insets.bottom,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BlurView style={{ ...StyleSheet.absoluteFillObject }} />
          <Box spaceVertical="medium">
            <AHButton
              onPress={() => {
                MailComposer.composeAsync({
                  recipients: ["support@storesprint.app"],
                  subject: "App: Support",
                  body: `



                
Beskriv ditt problem ovan så kontaktar vi dig så snabbt vi bara kan.
Skriv gärna ner ditt telefonnummer om du vill bli kontaktad via telefon eller sms!
              
              
              
              
              
        





----
Version: ${Constants.expoRuntimeVersion}
OS: ${Platform.OS}  ${Platform.Version} ${Device.modelId}
USR: ${usr.user.sub}
SID: ${getAuthSession()?.currentStoreId}`,
                });
              }}
              themeType="primary"
              style={{ flexDirection: "row", alignItems: "center" }}
            >
              <AHText color="lightText" type="subtitle" spaceRight="medium">
                Kontakta oss
              </AHText>
              <AHIcon color="lightText" type="message" />
            </AHButton>
          </Box>
        </Box>
      ) : null}
    </Box>
  );
}
